// @flow

import {createContext} from 'react';

export type DataTableContextType = {
    dataTableRef: {
        current: HTMLElement | null,
    },
    mainHeaderHeightRef: {current: number},
};

export const DataTableContext: React$Context<DataTableContextType> = createContext<DataTableContextType>({
    dataTableRef: {
        current: null
    },
    mainHeaderHeightRef: {current: 0},
});

DataTableContext.displayName = 'DataTableContext';
